import { hashTagsService } from "motw_core/Services/HashTagsService";
import * as React from "react";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { GetDreamRows } from "source/app/presentation/MainPanel/Dreams/HashTags/GetDreamRows";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";

export function HandleRenameHashTagRequest(
    setNewHashTagName: React.Dispatch<React.SetStateAction<string>>,
    hashTag: string,
    newHashTagName: string
) {
    WithAnimatedProgressBarAsync(async () => {
        setNewHashTagName(``);

        const dreams = GetDreamRows();

        await hashTagsService.RenameHashTagAsync(
            dreams,
            hashTag,
            `#${newHashTagName}`,
            ClientDataProvider
        );

        Data.Load.Single.ByStateTarget<IDreamsState>("dreamsdata");
    });
}
